module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-regular.479970f.woff2";